import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import api from "../../core/api/config";
import { useDispatch, useSelector } from "react-redux";
import { setAcessoAtivo } from "../../core/redux/access/accessActions";
import { TreeSelect } from "antd";
import "antd/dist/reset.css";
import { useMemo } from "react";
import { setAcessos } from "../../core/redux/access/accessActions";
import { setPerfilAtivo } from "../../core/redux/access/accessActions";
import { useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const dispatch = useDispatch();
  const { acessos, acessoAtivo, perfilAtivo } = useSelector(
    (state) => state.access,
  );

  const getNodeId = (node) => node?.idOrganograma ?? node?.id;
  const getNodeChildren = (node) => node?.filhos ?? node?.children ?? [];

  const treeData = useMemo(() => {
    const buildTree = (nodes) =>
      nodes.map((node) => ({
        title: `${node.descricao}${node.cnes ? ` (${node.cnes})` : ""}`,
        value: getNodeId(node),
        key: getNodeId(node),
        children: getNodeChildren(node).length
          ? buildTree(getNodeChildren(node))
          : [],
      }));

    return buildTree(acessos);
  }, [acessos]);
  const isDRS = Number(perfilAtivo?.tipo) === 3;

  const treeDataFinal = useMemo(() => {
    if (!isDRS) {
      // Se não for DRS, retorna apenas os dados normais
      return treeData;
    }

    // Se for DRS, adiciona o item "TODOS"
    const itemCustom = {
      title: "TODOS",
      value: "TODOS",
      key: "TODOS",
      children: [],
    };

    return [itemCustom, ...treeData];
  }, [treeData, isDRS]);

  const nodeMap = useMemo(() => {
    const map = {};
    const walk = (nodes) => {
      nodes.forEach((n) => {
        const nodeId = getNodeId(n);
        if (nodeId != null) {
          map[nodeId] = {
            ...n,
            idOrganograma: nodeId,
          };
        }

        const children = getNodeChildren(n);
        if (children.length) walk(children);
      });
    };
    walk(acessos);
    return map;
  }, [acessos]);

  const [toggle, setToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const carregarAcessos = async () => {
      try {
        // busca usuário real
        const user = await api.get("/api/user/show");
        const userId = user?.data?.user?.id;

        if (!userId) return;

        const { data } = await api.get(
          `/api/tracking/usuario/acesso?userId=${userId}`,
        );

        dispatch(setAcessos(data));
      } catch (error) {
        console.error("Erro ao carregar acessos:", error);
      }
    };

    carregarAcessos();
  }, [dispatch]);

  const handleLogout = async () => {
    const token = localStorage.getItem("token");

    try {
      if (token) {
        const logoutUrl = `/api/oauth/tokens/${token}`;

        await api.post(logoutUrl, null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    } catch (error) {
      if (error.response) {
        // Handle specific response errors
        if (error.response.status === 404) {
          console.error("Token não encontrado");
        } else if (error.response.status === 401) {
          console.error("Token inválido ou expirado");
        } else {
          console.error("Erro ao fazer logout:", error.response.data);
        }
      } else {
        console.error("Erro ao fazer logout:", error);
      }
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("acessoAtivo");
      localStorage.removeItem("perfilAtivo");

      // LIMPAR REDUX
      dispatch(setAcessos([]));
      dispatch(setAcessoAtivo(null));
      dispatch(setPerfilAtivo(null));

      navigate("/login", { replace: true });
    }
  };

  const isElementVisible = (element) => {
    if (!element) return false; // evita erro de null
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  useEffect(() => {
    const salvo = localStorage.getItem("acessoAtivo");

    if (salvo && !acessoAtivo) {
      try {
        const parsed = JSON.parse(salvo);
        dispatch(setAcessoAtivo(parsed));
      } catch (e) {
        console.error("Erro ao restaurar acesso ativo:", e);
        localStorage.removeItem("acessoAtivo");
      }
    }
  }, [dispatch, acessoAtivo]);

  useEffect(() => {
    const salvoPerfil = localStorage.getItem("perfilAtivo");

    if (salvoPerfil && !perfilAtivo) {
      try {
        const parsed = JSON.parse(salvoPerfil);
        dispatch(setPerfilAtivo(parsed));
      } catch (e) {
        console.error("Erro ao restaurar perfil ativo:", e);
        localStorage.removeItem("perfilAtivo");
      }
    }
  }, [dispatch, perfilAtivo]);

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();
      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);
    return () => document.removeEventListener("mouseover", handleMouseover);
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement,
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange,
      );
    };
  }, []);

  const handleSidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    setToggle((prev) => !prev);
  };

  const expandMenu = () => document.body.classList.remove("expand-menu");
  const expandMenuOpen = () => document.body.classList.add("expand-menu");

  const sidebarOverlay = () => {
    document.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document.querySelector("html")?.classList?.toggle("menu-opened");
  };

  const toggleFullscreen = (elem = document.documentElement) => {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
      else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
      else if (elem.webkitRequestFullscreen)
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    }
  };

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.includes(window.location.pathname)) {
    return null;
  }

  return (
    <>
      <div className="header">
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          <Link to="/" className="logo logo-normal">
            <img
              src="/assets/img/logo-horizontal.png"
              alt="Logotipo horizontal do ConeCta-SP"
            />
          </Link>
          <Link to="/" className="logo logo-white">
            <img
              src="/assets/img/logo-white.png"
              alt="Logotipo branco do ConeCta-SP"
            />
          </Link>
          <Link to="/" className="logo-small">
            <img
              src="/assets/img/logo-small.png"
              alt="Logotipo pequeno ConeCta-SP"
            />
          </Link>
          <Link
            id="toggle_btn"
            to="#"
            style={{
              display:
                pathname.includes("tasks") || pathname.includes("pos")
                  ? "none"
                  : pathname.includes("compose")
                    ? "none"
                    : "",
            }}
            onClick={handleSidebar}
          >
            <FeatherIcon icon="chevrons-left" className="feather-16" />
          </Link>
        </div>

        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>

        <ul className="nav user-menu float-end">
          <li className="nav-item nav-item-box">
            <TreeSelect
              showSearch
              labelInValue
              className="header-acesso-tree"
              popupClassName="header-acesso-tree-popup"
              style={{ width: 320 }}
              value={
                acessoAtivo
                  ? acessoAtivo.idOrganograma === "TODOS"
                    ? { value: "TODOS", label: "TODOS" }
                    : {
                        value: acessoAtivo.idOrganograma,
                        label: acessoAtivo.descricao,
                      }
                  : undefined
              }
              treeData={treeDataFinal}
              placeholder="Selecionar acesso"
              // treeDefaultExpandAll
              allowClear
              treeNodeFilterProp="title"
              filterTreeNode={(input, node) =>
                node.title.toLowerCase().includes(input.toLowerCase())
              }
              onChange={async (item) => {
                if (!item) return;

                //  TODOS
                if (item.value === "TODOS") {
                  const todos = {
                    idOrganograma: "TODOS",
                    descricao: "TODOS",
                  };

                  dispatch(setAcessoAtivo(todos));
                  localStorage.setItem("acessoAtivo", JSON.stringify(todos));

                  navigate("/charts-dashboard");
                  return;
                }

                const selecionado = nodeMap[item.value] || nodeMap[Number(item.value)];

                if (!selecionado) return;

                dispatch(setAcessoAtivo(selecionado));
                localStorage.setItem(
                  "acessoAtivo",
                  JSON.stringify(selecionado),
                );

                if (selecionado?.cidade) {
                  const novoPerfil = {
                    ...perfilAtivo,
                    cidade_id: selecionado.cidade,
                  };

                  dispatch(setPerfilAtivo(novoPerfil));
                  localStorage.setItem(
                    "perfilAtivo",
                    JSON.stringify(novoPerfil),
                  );
                }

                navigate("/admin-dashboard");
              }}
            />
          </li>

          <li className="nav-item nav-item-box">
            <Link
              to="#"
              id="btnFullscreen"
              onClick={() => toggleFullscreen()}
              className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              <FeatherIcon icon="maximize" />
            </Link>
          </li>

          <li className="nav-item dropdown has-arrow main-drop">
            {/* Usuário */}
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="user-detail">
                  <span className="user-name">
                    {perfilAtivo?.name || "Usuário"}
                  </span>
                </span>
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                {/* <Link className="dropdown-item">
                  <User className="me-2" /> Perfil
                </Link> */}
                <button
                  className="dropdown-item logout pb-0"
                  onClick={handleLogout}
                >
                  <img
                    src="/assets/img/icons/log-out.svg"
                    alt="Ícone de sair"
                    className="me-2"
                  />
                  Sair
                </button>
              </div>
            </div>
          </li>
        </ul>

        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {/* <Link className="dropdown-item" to="profile">
              Perfil
            </Link> */}
            <button className="dropdown-item" onClick={handleLogout}>
              Sair
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
